import {
  FormField,
} from '@codev/helix-react';
import PropTypes from 'prop-types';
import React from 'react';
import {
  FormControl,
} from 'react-bootstrap';
import languagesPropType from './languagesPropType.js';
import translate from './translate.js';

const CurrentPasswordFormField = ({
  currentPasswordFailed,
  language,
  onChange,
  value,
}) => {
  let validationProps = {};
  if (currentPasswordFailed) {
    validationProps ={
      validationMessage: translate('currentPasswordIncorrect', language),
      validationState: 'error',
    };
  }
  return (
    <FormField
      className="tall-form-group"
      isRequired
      isRequiredErrorMessage={translate('currentPasswordRequired', language)}
      label={translate('currentPassword', language)}
      value={value}
      {...validationProps}
    >
      <FormControl
        autoFocus
        onChange={event => onChange(event.target.value) }
        type="Password"
        value={value}
      />
    </FormField>
  );
};

CurrentPasswordFormField.defaultProps = {
  language: languagesPropType.defaultProp,
  value: '',
};

CurrentPasswordFormField.propTypes = {
  currentPasswordFailed: PropTypes.bool,
  language: languagesPropType.propType,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default CurrentPasswordFormField;